import { Trans } from "@lingui/macro"
import NavigateNextIcon from "@mui/icons-material/NavigateNext"
import { Typography, Box, Divider, Breadcrumbs } from "@mui/material"
import React from "react"
import { Link } from "react-router-dom"

import MarketplaceCreate from "../../components/modules/marketplace/MarketplaceCreate"
import { useMarketplace } from "../../contexts/MarketplaceContext"
import { ROUTE_LINKS } from "../../routes/routes"

const MarketplaceCreatePage = (): JSX.Element | null => {
  const { marketplaceProject } = useMarketplace()

  if (!marketplaceProject) return null

  return (
    <Box pt={1} pb={1}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          ml: 2,
          mr: 2,
        }}
      >
        <Box mb={0.5}>
          <Typography sx={{ flex: 1, color: "#F5F5F5", fontWeight: 500 }} variant="h4">
            <Trans>New Marketplace Contract</Trans>
          </Typography>
          <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ mt: 1 }}>
            <Link
              style={{ color: "#8C8C8C", textDecoration: "none" }}
              to={
                marketplaceProject
                  ? ROUTE_LINKS.marketplacesOnProject(marketplaceProject?.projectId)
                  : "#"
              }
            >
              {marketplaceProject?.name || "Project"}
            </Link>
            <Typography>New Marketplace Contract</Typography>
          </Breadcrumbs>
        </Box>
      </Box>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Box mb={4}>
        <MarketplaceCreate />
      </Box>
    </Box>
  )
}

export default MarketplaceCreatePage
